module.exports = __webpack_public_path__ + "img/undraw_my_password_re_ydq7.230fdd1b.svg";